import { WidgetRelatedApp } from '@inno-tools/container-bridge'
import { WIDGETS_CONFIG } from 'modules/desktop/modules/widgets/constants/widgetsConfig'
import type { User } from 'shared/types/user'
import { WidgetSpec } from 'shared/types/widgets'

export const buildMarketplaceWidgets = (
  activeApp: WidgetRelatedApp | null,
  user: User | null = null
): WidgetSpec[] => {
  const entries = Object.values(WIDGETS_CONFIG).filter(
    widget =>
      (activeApp
        ? (widget.relatedApp as WidgetRelatedApp) === activeApp
        : true) &&
      !widget.isHidden?.(user) &&
      !widget.marketplaceHidden
  )

  if (!entries.length) return []

  return entries.flatMap(widget =>
    widget.sizes.map(size => ({
      widgetKey: widget.key,
      size
    }))
  )
}
